<bw-action-article-legacy>
  <ui-nav-exit-back header-actions [trackingDetail]="{ event_name: 'waiting_dismissed' }"></ui-nav-exit-back>

  <div content-section>
    <ng-container>
      <div class="mb-xxl">
        <bw-steps-legacy [model]="items" [readonly]="true" [activeIndex]="stepIndex"></bw-steps-legacy>
      </div>
      <div class="mb-xxl"></div>
      <bw-spinner-legacy brightsideWebTimeout *ngIf="waiting"></bw-spinner-legacy>
      <div class="center">
      <div class="mb-sm"><bw-icon-legacy *ngIf="failed" iconName="red-alert" size="40"></bw-icon-legacy></div>
      <p text-large-semibold class="mb-xs">{{ actionHeader | translate }}</p>
      <p text-large-regular mwTextColor="var(--secondary-text)">
        {{ actionDescription1 | translate }}<br/>{{ actionDescription2 | translate }}
      </p>
      </div>
    </ng-container>
  </div>
</bw-action-article-legacy>

